import React, { useEffect } from 'react';

type Props = {
  containerId: string;
  ensureRendered: (containerId: string) => Promise<number | undefined>;
};

const RecaptchaV2: React.FC<Props> = ({ containerId, ensureRendered }) => {
  useEffect(() => {
    ensureRendered(containerId).catch(() => {});
  }, [containerId, ensureRendered]);

  return <div id={containerId} className="ips-waitlist-recaptcha" />;
};

export default RecaptchaV2;
